import type { FormEvent } from 'react';
import React from 'react';
import { HomeClubSectionFlow } from 'corgi-types';

import CartCTAButton from '../components/HomeClubContent/CartCTAButton';
import ContentCTAButton from '../components/HomeClubContent/ContentCTAButton';
import type { BaseComponentProps } from '../types';

interface GetComponentByFlowParams extends BaseComponentProps {
  flow: HomeClubSectionFlow;
  isLoading: boolean;
  handleModalOpen: () => void;
  handleSubmit: (event: FormEvent<HTMLFormElement>) => void;
}

export const getSubmitButton = ({
  flow,
  isLoading,
  handleSubmit,
  ...restProps
}: GetComponentByFlowParams) =>
  flow === HomeClubSectionFlow.Cart ? (
    <CartCTAButton
      isModalEnabled={false}
      isLoading={isLoading}
      handleSubmit={handleSubmit}
      {...restProps}
    />
  ) : (
    <ContentCTAButton {...restProps} />
  );
